import { useCallback, useState } from 'react';
import { IParent, IParentPayload, IParentResponse } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IParent';
import { getContainer } from '@framework/di/getContainer';
import CreditFlowResearchRepository from '@/creditflowresearch/infrastructure/repository/CreditFlowResearchRepository';
import { AlertManager } from '@creditflowresearch/uilib/Alert';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';

export const useArticlesParentsList = () => {
  const [selected, setSelected] = useState<IParent[]>([]);
  const [allowed, setAllowed] = useState<IParent[]>([]);
  const [isFetching, setIsFetching] = useState(false);
  const container = getContainer();

  const getParentsList = useCallback(async (payload: IParentPayload): Promise<IParentResponse> => {
    setIsFetching(true);

    try {
      const creditFlowResearchRepository = container.get<CreditFlowResearchRepository>(CreditFlowResearchRepository);
      const collectionParents = await creditFlowResearchRepository.getParentsList(payload);

      setSelected(collectionParents.selected);
      setAllowed(collectionParents.allowed);

      return collectionParents;
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
      return { allowed: [], selected: [] };
    } finally {
      setIsFetching(false);
    }
  }, [container]);

  return {
    isFetching,
    selected,
    allowed,
    getParentsList,
  };
};
